"use client";

import { createContext, useCallback, useContext, type ReactNode } from "react";
import { useFlowStepTracking } from "@portal/app/_components/hooks/useFlowStepTracking";

// Shared cards outside an opted-in results area do not report Explore progress.
const SchoolSelectionTrackingContext = createContext<() => void>(() => {});

export const SchoolSelectionTrackingProvider = ({ children }: { children: ReactNode }) => {
  const trackFlowStep = useFlowStepTracking("explore");
  const trackSchoolSelection = useCallback(() => {
    trackFlowStep({ stepNumber: 1, stepName: "school_match" });
  }, [trackFlowStep]);

  return (
    <SchoolSelectionTrackingContext.Provider value={trackSchoolSelection}>
      {children}
    </SchoolSelectionTrackingContext.Provider>
  );
};

export const useSchoolSelectionTracking = () => useContext(SchoolSelectionTrackingContext);
